export default {
  data() {
    return {
      packageType: [
        { id: 1, name: '安心套餐' },
        { id: 2, name: '灵活套餐' },
        { id: 3, name: '扩容包' },
      ],
      packageTypes: [
        { id: 1, name: '安心套餐' },
        { id: 2, name: '灵活套餐' },
      ],
      payMethod: [
        { id: 0, name: '线上支付' },
        { id: 1, name: '线下支付' },
        { id: 2, name: '企业转账' },
      ],
      payStatus: [
        { id: 1, name: '待支付' },
        { id: 2, name: '已支付' },
      ],

      payType: [
        { id: 'ALIPAY', name: '支付宝' },
        { id: 'WECHAT', name: '微信' },
        { id: 'UNIONPAY', name: '银联' },
      ],
      refundStatus: [
        { id: 0, name: '未退款' },
        { id: 1, name: '退款中' },
        { id: 2, name: '已退款' },
        { id: 3, name: '退款失败' },
      ],
      status: [
        { id: 0, name: '待支付' },
        { id: 6, name: '订单完成' },
        { id: 7, name: '订单取消' },
      ],
      useCoupon: [
        { id: 0, name: '未使用' },
        { id: 1, name: '使用' },
      ],
      invoiceStatus: [
        { id: 0, name: '未申请' },
        { id: 1, name: '申请中' },
        { id: 2, name: '已开具' },
        { id: 3, name: '已驳回' },
      ],
      invoiceInfo: [
        { id: 0, name: '未补充' },
        { id: 1, name: '已补充' },
      ],
      sourceType: [
        { id: 0, name: '自有池' },
        { id: 1, name: '企业分配池' },
      ],
      effectiveStatus: [
        { id: 0, name: '未生效' },
        { id: 1, name: '已生效' },
        { id: 2, name: '已过期' },
      ],
      expireStatus: [
        { id: 0, name: '已过期' },
        { id: 1, name: '未到期' },
      ],
      renewType: [
        { id: 0, name: '标准' },
        { id: 1, name: '开年存储' },
        { id: 2, name: '持续存储' },
      ],
      typeStatus: [
        { id: 0, name: '自有存储池' },
        { id: 1, name: '企业配额' },
      ],
      archiveStorageClass: [
        { id: 0, name: '标准' },
        { id: 1, name: '低频' },
        { id: 2, name: '深度' },
      ],
    }
  },
  filters: {
    formStatus(value, arr) {
      if (!arr) return ''
      const item = arr.find((v) => v.id == value)
      return item ? item.name : ''
    },
  },
  methods: {

  },
}
